module.exports = __webpack_public_path__ + "img/acc.35b2771c.svg";